// Exibe o modal da página institucional
(function () {
  'use strict';

  // Variáveis
  const $modalConsultaPedido = $('#modal-consulta-pedido');
  const $campoConsultaPedido = $('#cod-pedido');
  const $btnConsultaPedido = $('.btn-consulta-pedido');

  if ($campoConsultaPedido.length > 0) {
    handleNumConsulta();
  }

  // Ao digitar no campo
  $campoConsultaPedido.on('input change', handleNumConsulta);
  function handleNumConsulta() {
    if (validaCodPedido()) {
      $btnConsultaPedido.prop('disabled', false);
    } else {
      $btnConsultaPedido.prop('disabled', true);
    }
  }

  // Ao clicar no botão
  $btnConsultaPedido.on('click', function (ev) {
    ev.preventDefault();
    if (validaCodPedido()) {
      getPedido();
    } else {
      showAlert('Atenção', 'Informe o código do pedido.', 'warning');
    }
  });

  // Ao pressionar Enter no campo
  $campoConsultaPedido.on('keyup', function (ev) {
    if (ev.which === 13) {
      if (validaCodPedido()) {
        getPedido();
      }
    }
  });

  // Valida a código digitado
  function validaCodPedido() {
    let codPedido = $campoConsultaPedido.val();
    return codPedido && codPedido != '';
  }

  // Consulta o pedido
  function getPedido() {
    if (!previewMode) {
      let codPedido = $campoConsultaPedido.val();
      codPedido = codPedido.split('')[0] === '#' ? codPedido.replace('#', '') : codPedido;
      codPedido = codPedido.toUpperCase();
      const urlConsultaPedido = urlBase + 'store/core/acoes/checkout/searchOrder.php';
      const data = {
        order_token: codPedido,
        store_token: publicToken,
      };
      showLoader();
      $.getJSON(urlConsultaPedido, data, function (result) {
        //console.log(result);
        if (result && result.token != '') {
          let urlPedido = urlBaseLp + 'checkout/pedido?order=' + result.token;
          location.href = urlPedido;
        } else {
          hideLoader();
          showAlert('Não encontrado!', 'Não encontramos nenhum pedido para o código informado.', 'danger');
        }
      }).fail(function (qXHR, textStatus, errorThrown) {
        console.log(qXHR);
        hideLoader();
        showAlert('Erro', 'Não foi possível realizar esta operação.', 'danger');
      });
    }
  }
})();
